module.exports = __webpack_public_path__ + "static/media/js.959421b3.svg";